import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import PATHS from '$_myrotra/paths';
import NotFoundPage from '$components/pages/errors/NotFoundPage';

interface RoutesGuardProps {
  children: React.ReactNode;
}

function RoutesGuard({ children }: RoutesGuardProps) {
  const location = useLocation();

  const notFoundPath = location.pathname;

  return (
    <Switch>
      {/*
        Example: <Redirect from="/users/:id" to="/users/profile/:id" />
        Place Redirects above the {children} render
      */}
      {/*
       NOTE: START OLD ROUTES REDIRECTS
      */}
      <Redirect from="/quotations/contracts" to={PATHS.contracts.root} />
      <Redirect
        from="/quotations/contracts/:id"
        to={PATHS.contracts.details(':id')}
      />
      <Redirect from="/quotations/spot-rates" to={PATHS.quotes.spot_rates.root} />
      <Redirect
        from="/quotations/spot-rates/:id"
        to={PATHS.quotes.spot_rates.details(':id')}
      />
      <Redirect
        from="/quotations/book/quotation/:id"
        to={PATHS.quotes.spot_rates.book(':id')}
      />
      <Redirect from="/quotations/requests" to={PATHS.quotes.quote_requests.root} />
      <Redirect
        from="/quotations/requests/:id"
        to={PATHS.quotes.quote_requests.details(':id')}
      />
      <Redirect
        from="/quotations/requests/new"
        to={PATHS.quotes.quote_requests.new}
      />
      {/*
        NOTE: END OLD ROUTES REDIRECTS
      */}

      {children}
      <Route>
        <NotFoundPage notFoundPath={notFoundPath} />
      </Route>
    </Switch>
  );
}

export default RoutesGuard;
